import { css } from 'styled-components/macro';

export const DS_FONTS = {
  'heading-1': {
    fontSize: '32px',
    lineHeight: '40px',
    fontWeight: '500',
    css: css`
      font-family: 'Roboto', sans-serif;
      font-size: 32px;
      line-height: 40px;
      font-weight: 500;
    `,
  },
  'heading-2': {
    fontSize: '24px',
    lineHeight: '32px',
    fontWeight: '500',
    css: css`
      font-family: 'Roboto', sans-serif;
      font-size: 24px;
      line-height: 32px;
      font-weight: 500;
    `,
  },
  'heading-3': {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: '500',
    css: css`
      font-family: 'Roboto', sans-serif;
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
    `,
  },
  'heading-4': {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: '500',
    css: css`
      font-family: 'Roboto', sans-serif;
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
    `,
  },
  'heading-5': {
    fontSize: '13px',
    lineHeight: '16px',
    fontWeight: '500',
    css: css`
      font-family: 'Roboto', sans-serif;
      font-size: 13px;
      line-height: 16px;
      font-weight: 500;
    `,
  },
  'body-16': {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: '400',
    css: css`
      font-family: 'Roboto', sans-serif;
      font-size: 16px;
      line-height: 24px;
      font-weight: 400;
    `,
  },
  'body-14': {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: '400',
    css: css`
      font-family: 'Roboto', sans-serif;
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
    `,
  },
  'caption-13': {
    fontSize: '13px',
    lineHeight: '16px',
    fontWeight: '400',
    css: css`
      font-family: 'Roboto', sans-serif;
      font-size: 13px;
      line-height: 16px;
      font-weight: 400;
    `,
  },
  'numbers-13': {
    fontSize: '13px',
    lineHeight: '16px',
    fontWeight: '400',
    css: css`
      font-family: 'Roboto Mono';
      font-size: 13px;
      line-height: 16px;
      font-weight: 400;
    `,
  },
  'caption-11': {
    fontSize: '11px',
    lineHeight: '12px',
    fontWeight: '400',
    css: css`
      font-family: 'Roboto', sans-serif;
      font-size: 11px;
      line-height: 12px;
      font-weight: 400;
    `,
  },
  'button-16': {
    fontSize: '16px',
    lineHeight: '16px',
    fontWeight: '400',
    css: css`
      font-family: 'Roboto', sans-serif;
      font-size: 16px;
      line-height: 16px;
      font-weight: 400;
    `,
  },
  'button-14': {
    fontSize: '14px',
    lineHeight: '16px',
    fontWeight: '400',
    css: css`
      font-family: 'Roboto', sans-serif;
      font-size: 14px;
      line-height: 16px;
      font-weight: 400;
    `,
  },
  'button-12': {
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: '400',
    css: css`
      font-family: 'Roboto', sans-serif;
      font-size: 12px;
      line-height: 16px;
      font-weight: 400;
    `,
  },
} as const;
